import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslationModule } from '@fino-ui/translation';
import { KeycloakService } from 'keycloak-angular';
import { remove } from 'lodash-es';
import { AppService } from 'src/app/app.service';
import { NavbarMainRoutes } from 'src/app/core/routes/routes';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.sass'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLinkActive, RouterLink, TranslationModule],
})
export class NavbarComponent implements OnInit {
  constructor(
    private authService: KeycloakService,
    private appService: AppService,
  ) {}

  routes = [];
  userRoles: string[] = [];

  ngOnInit(): void {
    this.userRoles = this.authService.getUserRoles();
    this.setupRoutes();
  }

  get isAtruvia() {
    return this.appService.isAtruvia;
  }

  setupRoutes() {
    this.routes = NavbarMainRoutes;
    const { availableProducts } = this.appService;

    if (!availableProducts().canConfigureKwh) {
      remove(this.routes, { name: 'kwh' });
    }

    if (!availableProducts().canConfigureKws) {
      remove(this.routes, { name: 'kws' });
    }

    if (this.isAtruvia || !availableProducts().hasDws) {
      remove(this.routes, { name: 'dws' });
    }
  }

  logout() {
    this.authService.logout();
  }

  hasRole(role: string) {
    return this.userRoles.includes(role);
  }

  get logoUrl() {
    return this.appService.logoUrl;
  }
}
